import type { FaireProductEntity } from "../../entity_types/product";

export const p_n6dtm235cm: FaireProductEntity = {
  token: "p_n6dtm235cm",
  type: "product",
  name: "Ginger Peach Glow - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/163028631fba4a680f2cea977a0747e2b1129e7871e484c81933c7aa5b2dd248.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/62171caff9a6131e498675923c9bd382842f779451523ebdca7709b8deb9d02d.jpeg",
    "https://cdn.faire.com/fastly/b2b3ea1282007ce1ffa689cf433f825491947b30f5751a733a88143c430c2254.jpeg"
  ],
  priceDollars: 58,
  description: "SUPERFOOD TEA BLEND \n\nThis juicy blend combines the sun-drenched sweetness of real peach with a gentle kiss of ginger to spark your digestion and refresh you from the inside out. Skin-loving hibiscus and orange—nature’s little powerhouses of antioxidants—to help you maintain that summer glow. Try it iced with a drizzle of honey and squeeze of fresh peaches for the ultimate summer sip. \n\n100% ORGANIC - NUTRITIONIST FORMULATED - SUGAR FREE\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Sweeten to taste with a drizzle of maple syrup. \n * Iced Tea: Steep 1 tbsp Ginger Peach Glow in 1 cup of boiling water for at least 5 minutes. Sweeten to taste. Top with 1 heaping cup of ice. \nWhen to Steep:\n\n\n *  As an iced tea to hydrate midday. \n * After a meal to ease digestion. \n * At a summer garden party, a picnic, on the beach, or with brunch. \n * A nourishing all day caffeine-free tea \nCaffeine-free\n\n\n\n",
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:39.810Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
